module.exports = __webpack_public_path__ + "img/google.17d4f30c.png";